import { render, staticRenderFns } from "./YzTruncatedList.vue?vue&type=template&id=1ce2e5ce&scoped=true&lang=pug&"
import script from "./YzTruncatedList.vue?vue&type=script&lang=js&"
export * from "./YzTruncatedList.vue?vue&type=script&lang=js&"
import style0 from "./YzTruncatedList.vue?vue&type=style&index=0&id=1ce2e5ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce2e5ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
